var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_13783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.61027 1.63306H1.50909C1.1914 1.63306 0.933899 1.8906 0.933899 2.20825V17.9001C0.933899 18.1579 1.14292 18.3669 1.4007 18.3669H2.71866C2.97648 18.3669 3.18546 18.1579 3.18546 17.9001V2.20825C3.18546 1.89056 2.92792 1.63306 2.61027 1.63306Z",
    fill: "#D4D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3892 1.63306H18.4904C18.8081 1.63306 19.0656 1.8906 19.0656 2.20825V17.9001C19.0656 18.1579 18.8566 18.3669 18.5988 18.3669H17.2808C17.023 18.3669 16.814 18.1579 16.814 17.9001V2.20825C16.814 1.89056 17.0716 1.63306 17.3892 1.63306Z",
    fill: "#D4D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90723 3.08472L1.00805 3.95843L0 5.99202V9.12909L3.96508 6.69362L6.04434 3.08472H2.90723Z",
    fill: "#465059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93549 3.08472L3.96506 6.69362L1.71771 10.3025H4.85482L9.39513 7.37237L12.0726 3.08472H8.93549Z",
    fill: "#465059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9631 3.08472L9.39458 7.37237L7.74536 10.3025H10.8825L15.4409 7.21378L18.1002 3.08472H14.9631Z",
    fill: "#465059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9637 7.85623L13.7742 10.3025H16.9113L19.1533 9.12908L20 7.21377V4.07666L14.9637 7.85623Z",
    fill: "#465059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 7.21387V9.36871C20.0003 9.88445 19.5822 10.3026 19.0665 10.3026H16.9116L20.0003 7.21387Z",
    fill: "#FFCD38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 4.01862V4.07671L13.7737 10.3025H10.8826L18.1003 3.08472H19.0656C19.5813 3.08472 19.9995 3.50288 19.9995 4.01862Z",
    fill: "#FFCD38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9637 3.08472L7.74595 10.3025H4.85486L12.0726 3.08472H14.9637Z",
    fill: "#FFCD38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93551 3.08472L1.71773 10.3025H0.933867C0.418164 10.3025 0 9.88433 0 9.36858V9.12905L6.04434 3.08472H8.93551Z",
    fill: "#FFCD38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90723 3.08472L0 5.99202V4.01862C0 3.50288 0.418164 3.08476 0.933867 3.08476L2.90723 3.08472Z",
    fill: "#FFCD38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18566 10.3022H0.934021V11.5171H3.18566V10.3022Z",
    fill: "#BAB8B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0658 10.3022H16.8141V11.5171H19.0658V10.3022Z",
    fill: "#BAB8B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_13783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWip);
export default __webpack_public_path__ + "static/media/wip.3e3cfd42f98b4b6c2a3815b00883c373.svg";
export { ForwardRef as ReactComponent };